export const IS_MFA_ENABLE = "IS_MFA_ENABLE";

const initialState = {
  isMFAEnable: true,
  type: 0,
};

const twoFactorAuthenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_MFA_ENABLE:
      return {
        ...state,
        isMFAEnable: Boolean(action.value),
        type: action.value.type ? action.value.type : 0,
      };

    default:
      return state;
  }
};

export default twoFactorAuthenticationReducer;
